import React, { useEffect, useState } from "react";
import { Progress } from "../Progress";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { useCreditSelector } from "../../stores/product/product.store";
import { setShippingZone } from "../../stores/credit/credit.reducer";

interface OrderButtonProps {
    onSubmit: () => void;
}

export const OrderButton: React.FC<OrderButtonProps> = ({ onSubmit }) => {
    const text = useCreditSelector((state: CreditState) => state.text);
    const loader = useCreditSelector((state: CreditState) => state.loader);
    const terms = useCreditSelector((state: CreditState) => state.terms);
    const marketing = useCreditSelector((state: CreditState) => state.marketing);
    
    const shippingMethod = useCreditSelector((state: CreditState) => state.shipping.selectShippingMethod);
    const shippingAddress = useCreditSelector((state: CreditState) => state.shipping.shippingAddress);
    const shippingZone = useCreditSelector((state: CreditState) => state.shipping.shippingZone);
    const shippingCity = useCreditSelector((state: CreditState) => state.shipping.shippingCity);
    const shippingCityId = useCreditSelector((state: CreditState) => state.shipping.shippingCityId);
    const shippingPickup = useCreditSelector((state: CreditState) => state.shipping.shippingPickup);
    const contactMethod = useCreditSelector((state: CreditState) => state.contactMethod);
    
    const [disabled, setDisabled] = useState(Boolean((!terms && !marketing) || loader));
    
    useEffect(() => {
        if(shippingMethod === null) {
            setDisabled(true);
        } else if(shippingMethod?.code === '_RR_') {
            setDisabled(!shippingPickup || (!terms && !marketing) || loader);
        } else if(shippingMethod?.code === '_ONP_' || shippingMethod?.code === '_SBOX_') {
            if (shippingMethod?.code === '_ONP_' && shippingMethod?.hubOnly) {
                setDisabled(!shippingPickup || (!terms && !marketing) || loader);
            } else {
                setDisabled(!shippingPickup || !shippingCityId || !shippingZone || (!terms && !marketing) || loader);
            }
        } else if(shippingMethod?.code === '_LLU_') {
            setDisabled((!shippingAddress.trim() || !shippingCity.trim()) || (!terms && !marketing) || loader);
        } else {
            setDisabled((!terms && !marketing) || loader);
        }

        if(loader) {
            setDisabled(true);
        }
    }, [disabled, loader, marketing, shippingAddress, shippingCity, shippingMethod, terms, contactMethod, shippingPickup, shippingZone, shippingCityId]);
    

    return (
        <>
            <button
                disabled={ disabled }
                onClick={ () => onSubmit() }
                className={ `font-semibold w-full rounded-xl ${ disabled ? 'bg-light-dark-gray text-white' : 'bg-yellow text-dark-gray' } h-14` }
            >{ text.createOrder }</button>
            { loader && <div className="mt-2">
                <Progress/>
            </div> }
        </>
    )
}